import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CountUp from 'react-countup';
import { useInViewport } from 'react-in-viewport';

const Counter = ({ icon, text, value, symbol, duration = 1 }) => {
  const ref = useRef(null);
  const { inViewport } = useInViewport(
    ref,
    { rootMargin: '0px' },
    { disconnectOnLeave: false },
    { triggerOnce: true }
  );

  const [animationComplete, setAnimationComplete] = useState(false);

  useEffect(() => {
    if (inViewport && !animationComplete) {
      setAnimationComplete(true);
    }
  }, [inViewport, animationComplete]);

  return (
    <div className='counter_component' ref={ref}>
      <div className='icon'>
        <FontAwesomeIcon icon={icon} />
      </div>
      <div className='value'>
        <CountUp
          start={0}
          end={animationComplete ? value : 0}
          duration={duration}
        />
        <span className='symbol'>{symbol}</span>
      </div>
      <div className='text'>{text}</div>
    </div>
  );
};

export default Counter;
